import { useEffect } from "react";

// Close an overlay with the Escape key while it is open.
export default function useEscape(active, onClose) {
  useEffect(() => {
    if (!active || !onClose) return undefined;
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [active, onClose]);
}
